import { setDefaultAssets } from '@leagueplatform/asset-config';
import { CLAIMS_ASSETS } from './asset-map';

export const initModule = () => {
  setDefaultAssets(CLAIMS_ASSETS);
};
